import { useAppClockService } from '@mews/framework';
import { ExportFormat } from '@mews-commander/data-access';
import { CityLedgerExportField } from '../exportSchema';

export const useDefaultExportValues = () => {
    const appClockService = useAppClockService();
    const now = appClockService.getAppNowUtc().value;

    return {
        [CityLedgerExportField.format]: ExportFormat.Excel,
        [CityLedgerExportField.date]: now,
        [CityLedgerExportField.owner]: '',
        [CityLedgerExportField.ownerTypes]: [],
        [CityLedgerExportField.invoiceStatus]: [],
        [CityLedgerExportField.balanceMin]: 0,
        [CityLedgerExportField.balanceMax]: 0,
        [CityLedgerExportField.ageing]: [],
    };
};
